import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import ConfiguratorHome from './components/ConfiguratorHome';
import ConfiguratorApp from './components/ConfiguratorApp';
import AuditChaufferie from './components/AuditChaufferie';
import AuditChaufferieVertical from './components/AuditChaufferieVertical';

function App() {
  return (
    <Router basename="/configuration">
      <Routes>
        {/* Page d'accueil React sur /configurateur */}
        <Route path="/" element={<Home />} />
        <Route path="/configurator-home" element={<ConfiguratorHome />} />
        <Route path="/configurateur" element={<ConfiguratorApp />} />
        <Route path="/audit-chaufferie" element={<AuditChaufferieVertical />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;